import { Tracker } from './index';

declare global {
  interface Window {
    BrainfishAnalytics: {
      q?: [string, ...any[]];
      (method: string, ...args: any[]): void;
    };
  }
}

((window) => {
  if (window.BrainfishAnalytics && 'q' in window.BrainfishAnalytics) {
    const queue = window.BrainfishAnalytics.q || [];
    const initIndex = queue.findIndex((e) => e[0] === 'init');
    if (initIndex === -1) {
      console.warn('BrainfishAnalytics has not been initialized.');
      return;
    }

    const [init] = queue.splice(initIndex, 1);
    const tracker = new Tracker(init[1]) as any;
    queue.forEach((item) => {
      if (item[0] in tracker) {
        tracker[item[0]](...item.slice(1));
      }
    });

    window.BrainfishAnalytics = (t, ...args) => {
      const fn = tracker[t] ? tracker[t].bind(tracker) : undefined;
      if (typeof fn === 'function') {
        fn(...args);
      } else {
        console.warn(`Method ${t} does not exist on BrainfishAnalytics`);
      }
    };
  }
})(window);
